module.exports = __webpack_public_path__ + "media/images/papir4d-6c6751b2.svg";